module.exports = __webpack_public_path__ + "static/img/gift-box-reward-comment-img.4a06e5a.png";